var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7068 7.29262C19.3162 6.90225 18.683 6.90249 18.2926 7.29316L10.2926 15.2993C9.90246 15.6898 9.90246 16.3225 10.2926 16.713L18.2803 24.7068C18.6707 25.0975 19.3039 25.0978 19.6945 24.7074C20.0852 24.317 20.0855 23.6838 19.6951 23.2932L12.4137 16.0062L19.7074 8.70683C20.0978 8.31616 20.0975 7.683 19.7068 7.29262Z",
    fill: "#000000",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.1ff5214da4a868d5d0023395cbc95ade.svg";
export { ForwardRef as ReactComponent };